import React from "react";
import { QrCodeOverlay } from "../../views/Overlays/QrOverlay";
import Loader from "../../components/Loader";
import { WaitForConfig } from "../../components/WaitForConfig";
import { useFonts } from "../../components/FontSelector/useFont";
import { OVERLAY_TYPE } from "../../hooks/useOverlaySettings";

const QR = (query) => {
  const { bodyFont = "IBM Plex Mono" } = query;
  useFonts({ fonts: [{ family: bodyFont }] });
  if (query.username) {
    return <QrCodeOverlay {...query} />;
  }
  return <Loader />;
};

const QRWidget = () => {
  return <WaitForConfig Component={QR} overlayType={OVERLAY_TYPE.QR} />;
};

export default QRWidget;
